
//
// Color indicies
//
export enum ColorIndex {
    Red,
    Green,
    Blue,
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/ng2-file-drop/properties/color-index.ts